/**
 * Card for displaying upcoming, paid, and past-due invoices.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';

import PromotionItem from './PromotionItem/PromotionItem';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  className: PropTypes.string.isRequired,
  org: PropTypes.shape({
    dtCreated: PropTypes.string.isRequired,
    trialCreditCents: PropTypes.number.isRequired,
    billingSetupComplete: PropTypes.bool.isRequired,
    supportLevelName: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledPromotionCard({ classes, className, org }) {
  const { dtCreated, trialCreditCents, billingSetupComplete, supportLevelName } = org;

  return (
    <Card className={className}>
      <CardHeader title="Promotional Credits" />
      <CardContent>
        <Table className={classes.table}>
          <PromotionItem
            key={dtCreated}
            status="Free Trial"
            dtCreated={dtCreated}
            trialCreditCents={trialCreditCents}
            billingSetupComplete={billingSetupComplete}
          />
          {supportLevelName === 'Promotional_20_Percent' ? (
            <PromotionItem
              key={dtCreated}
              status="Promotional Pricing"
              dtCreated={dtCreated}
              discount={20}
            />
          ) : null}
        </Table>
      </CardContent>
    </Card>
  );
}

UnstyledPromotionCard.propTypes = propTypes;

const styles = () => ({
  table: {
    '& tr:last-child td': {
      borderBottom: 'none',
    },
  },
});

export default withStyles(styles)(UnstyledPromotionCard);
